import React from 'react'

export default function FormattedPhone(props: {
  phone: string
  clickable?: boolean
}): React.ReactElement {
  const { phone, clickable } = props
  return clickable ? <a href={`tel:${phone}`}>{phone}</a> : <>{phone}</>
}
